import { ElementType, FC } from 'react'

import MinusIcon from '../../Icons/MinusIcon'
import PlusIcon from '../../Icons/PlusIcon'

interface AttributeTitleProps {
  eventKey: number
  tabId: number
  text: string
  isExpandable: boolean
  as?: ElementType
}

const AttributeTitle: FC<AttributeTitleProps> = (props) => {
  const {
    eventKey,
    tabId,
    isExpandable,
    text,
    as: Tag = 'p',
  } = props

  const icon = eventKey === tabId ? <MinusIcon /> : <PlusIcon />

  return (
    <Tag
      data-testid="product-attribute-title"
      className={`product-attribute-title ${!isExpandable ? 'not-expandable' : 'is-expandable'}`}
    >
      <span
        className="align-middle"
        role="button"
      >
        {isExpandable ? icon : ''}
      </span>
      {text}
    </Tag>
  )
}

export default AttributeTitle
